import React from 'react'
import { useSelector } from 'react-redux'

import {
  isAssignedToActivePilotageSelector,
  isPilotageDoneSelector,
  isPilotageArchivedSelector,
  isPilotageCancelledSelector,
  movementTypeSelector,
} from 'src/store/pilotage/selectors'
import PilotageChecklistBase from 'src/components/organisms/PilotageChecklist/PilotageChecklistBase'
import { ChecklistComment } from 'src/components/molecules/ChecklistComment'

export const PilotageChecklist: React.FC = () => {

  const movementType = useSelector(movementTypeSelector)
  const isAssigned = useSelector(isAssignedToActivePilotageSelector)
  const isPilotageDone = useSelector(isPilotageDoneSelector)
  const isPilotageArchived = useSelector(isPilotageArchivedSelector)
  const isPilotageCancelled = useSelector(isPilotageCancelledSelector)
  const isReadOnly =
    !isAssigned || isPilotageDone || isPilotageArchived || isPilotageCancelled

  return (
    <PilotageChecklistBase
      readOnly={isReadOnly}
      CommentComponent={ChecklistComment}
      movementType={movementType}
    />
  )
}
